import React, { createContext, useContext, useReducer } from "react"

const ModalContext = createContext<[State, React.Dispatch<Action>]>(null as any)

type State = {
  [id: string]: boolean | undefined
}
type Action = {
  [id: string]: boolean
}

const reducer = (state: State, action: Action): State => {
  return {
    ...state,
    ...action,
  }
}

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const value = useReducer(reducer, {})

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
}

export const useModal = (id: string) => {
  const [state, setState] = useContext(ModalContext)

  const open = () => setState({ [id]: true })
  const close = () => setState({ [id]: false })
  const isOpen = state[id] ?? false

  return { open, close, isOpen }
}
